"use client";

import { RiCalendarLine } from "@remixicon/react";
import {
	Select,
	SelectContent,
	SelectItem,
	SelectTrigger,
	SelectValue,
} from "@workspace/ui/components/select";
import { memo } from "react";
import { cn } from "@/lib/utils";

interface ProfileYearSelectorProps {
	selectedYear: string;
	onYearChange: (value: string) => void;
	availableYears?: number[]; // Will be calculated based on user's data
	className?: string;
}

export const ProfileYearSelector = memo(function ProfileYearSelector({
	selectedYear,
	onYearChange,
	availableYears,
	className,
}: ProfileYearSelectorProps) {
	// Default years if none provided
	const years = availableYears || [2025, 2024, 2023];

	return (
		<Select value={selectedYear} onValueChange={onYearChange}>
			<SelectTrigger
				className={cn(
					"hover:bg-accent hover:text-accent-foreground active:scale-[0.99]",
					className,
				)}
			>
				<div className="flex items-center gap-2">
					<RiCalendarLine className="h-4 w-4 shrink-0" />
					<SelectValue placeholder="Select year" />
				</div>
			</SelectTrigger>
			<SelectContent>
				<SelectItem value="all">All Years</SelectItem>
				{years.map((year) => (
					<SelectItem key={year} value={year.toString()}>
						{year}
					</SelectItem>
				))}
			</SelectContent>
		</Select>
	);
});

ProfileYearSelector.displayName = "ProfileYearSelector";
